import { render, staticRenderFns } from "./UsersPrivilegeReservationsSchedulesPayments.vue?vue&type=template&id=351e1013&scoped=true&"
import script from "./UsersPrivilegeReservationsSchedulesPayments.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeReservationsSchedulesPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351e1013",
  null
  
)

export default component.exports